import { AuthStore } from '@/domain/models/Store';
import { DASHBOARD_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
interface Interface {
  list: () => Promise<AuthStore[]>;
}

export class StoreService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async list(): Promise<AuthStore[]> {
    return await this.restClient.get<AuthStore[]>(
      `${DASHBOARD_API_ORIGIN}/api/auth-stores` as const
    );
  }
}
